import React from 'react';
import { motion } from 'framer-motion';
import { FaYoutube, FaInstagram, FaFacebook, FaMusic } from 'react-icons/fa';

const platforms = [
  { id: 'youtube', name: 'YouTube', icon: FaYoutube, color: 'from-red-500 to-red-600' },
  { id: 'instagram', name: 'Instagram', icon: FaInstagram, color: 'from-pink-500 to-purple-600' },
  { id: 'facebook', name: 'Facebook', icon: FaFacebook, color: 'from-blue-500 to-blue-600' },
  { id: 'tiktok', name: 'TikTok', icon: FaMusic, color: 'from-gray-700 to-gray-800' },
];

const PlatformCards = ({ selectedPlatform, onSelectPlatform }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {platforms.map((platform, index) => {
          const Icon = platform.icon;
          const isSelected = selectedPlatform === platform.id;

          return (
            <motion.button
              key={platform.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              onClick={() => onSelectPlatform(platform.id)}
              className={`platform-card relative p-6 rounded-2xl transition-all border-2 ${
                isSelected ? 'shadow-lg' : 'hover:shadow-md'
              }`}
              style={{
                backgroundColor: isSelected ? 'var(--primary)' : 'var(--background)',
                borderColor: isSelected ? 'var(--accent)' : 'var(--primary)',
                color: 'var(--text)'
              }}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="flex flex-col items-center gap-3">
                <Icon 
                  size={40} 
                  style={{ color: isSelected ? 'var(--text)' : 'var(--accent)' }}
                />
                <span 
                  className="font-semibold"
                  style={{ color: 'var(--text)' }}
                >
                  {platform.name}
                </span>
              </div>
              {isSelected && (
                <motion.div
                  className="absolute inset-0 rounded-2xl pointer-events-none"
                  style={{
                    boxShadow: `0 0 20px var(--accent)`
                  }}
                  animate={{
                    opacity: [0.5, 1, 0.5],
                  }}
                  transition={{ duration: 2, repeat: Infinity }}
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default PlatformCards;
